import { createAsyncThunk } from '@reduxjs/toolkit';
import { ServicesService } from '../../../epics/region_services/services';
import { ServicesAllService } from '../../../epics/region_services/services/all';
import {
    addServicesKey,
    deleteServicesKey,
    editServicesKey,
    getServicesKey,
    getServicesListKey,
    servicesAllKey,
    servicesAllListKey,
    updateServicesKey,
} from './servicesKeys';
import { clearServicesKey } from '../../common/thunkKeys/servicesThunksKeys';
import { clearNameServices } from '../../common/services_reducers/nameServices';
import { clearTypeServices } from '../../common/services_reducers/typeServices';
import {
    getNameServices,
    getTypeServices,
} from '../../common/thunks/servicesThunks';

export const addServices = createAsyncThunk(
    addServicesKey,
    async (values, thunkAPI) => {
        try {
            return await ServicesService.addServices(values);
        } catch (error) {
            return thunkAPI.rejectWithValue({
                message: error?.message || error?.error || 'unknown',
                details: error?.details || null,
            });
        }
    },
);

export const getServices = createAsyncThunk(
    getServicesKey,
    async (id, thunkAPI) => {
        try {
            const response = await ServicesService.getServices(id);
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const getServicesList = createAsyncThunk(
    getServicesListKey,
    async (payload, thunkAPI) => {
        try {
            const response = await ServicesService.getServicesList(payload);
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const deleteServices = createAsyncThunk(
    deleteServicesKey,
    async (id, thunkAPI) => {
        try {
            const response = await ServicesService.deleteServices(id);
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const editServices = createAsyncThunk(
    editServicesKey,
    async (updates, thunkAPI) => {
        try {
            const response = await ServicesService.editServices(updates);
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const updateServices = createAsyncThunk(
    updateServicesKey,
    async (updates, thunkAPI) => {
        try {
            const response = await ServicesService.updateServices(updates);
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const getServicesAllList = createAsyncThunk(
    servicesAllListKey,
    async (payload, thunkAPI) => {
        try {
            const response = await ServicesAllService.getServicesAllList(payload);
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const getServicesAll = createAsyncThunk(
    servicesAllKey,
    async (id, thunkAPI) => {
        try {
            const response = await ServicesAllService.getServicesAll(id);
            return response;
        } catch (error) {
            return thunkAPI.rejectWithValue(error.message);
        }
    },
);

export const clearServicesDataAction = createAsyncThunk(
    clearServicesKey,
    (_, { dispatch }) => {
        dispatch(clearNameServices());
        dispatch(clearTypeServices());

        dispatch(getNameServices());
        dispatch(getTypeServices());
    },
);
